import noop from 'lodash/fp/noop'
import * as React from 'react'

export type AppContextType = {
  isFullyInitialized: boolean
  isRefetchingAppData: boolean
  onAppDataLoaded: () => void
  setIsRefetchingAppData: (value: boolean) => void
}

export const initialAppState = {
  isFullyInitialized: false,
  isRefetchingAppData: false,
  onAppDataLoaded: noop,
  setIsRefetchingAppData: noop,
}

export const AppContext = React.createContext<AppContextType>(initialAppState)

export const useAppContext = (): AppContextType => React.useContext(AppContext)
